import Rates from 'app/collections/rates';
import ShippingCalculatorFormView from 'app/views/shipping_calculator_form_view';
import RateListView from 'app/views/rate_list_view';

import Base from 'app/views/base';
import tmpl from 'templates/shipping_calculator';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {},

  initialize() {
    this.collection = new Rates([], {});
    this.addSubview('form', '#calculator_form', new ShippingCalculatorFormView({ collection: this.collection }));
    this.addSubview('rate_list', '#rate_list', new RateListView({ collection: this.collection }));
  },
});




// WEBPACK FOOTER //
// ./app/views/shipping_calculator_page.js